import { render } from "./MergeGroupsForm.vue?vue&type=template&id=0f366710&scoped=true"
import script from "./MergeGroupsForm.vue?vue&type=script&lang=js"
export * from "./MergeGroupsForm.vue?vue&type=script&lang=js"

import "./MergeGroupsForm.vue?vue&type=style&index=0&id=0f366710&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f366710"]])

export default __exports__